const cardSlider = document.querySelectorAll('.js-slider-swiper')

const defaultSliderOptions = {
  speed: 1000,
  watchOverflow: true,
  observer: true,
  resizeObserver: true,
  navigation: {
    nextEl: '.js-swiper-button-next',
    prevEl: '.js-swiper-button-prev'
  }
}

export const initSlider = (elem) => {
  if (!elem) return

  const countsElements = elem.querySelectorAll('.js-slider-swiper-item').length
  const sliderOptions = {...defaultSliderOptions}

  if (elem.hasAttribute('data-autoplay')) {
    sliderOptions.autoplay = {
      delay: 2200,
      disableOnInteraction: false
    }
  }

  sliderOptions.effect = 'fade'
  sliderOptions.fadeEffect = {
    crossFade: true
  }
  sliderOptions.loop = true
  sliderOptions.autoHeight = (countsElements > 1)

  const swiper = new Swiper(elem, sliderOptions)
}

if (cardSlider.length > 0) {
  cardSlider.forEach((elem) => {
    initSlider(elem)
  })
}
